/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

/**
 * Save the current document to the Ecsper Vault.
 * Registered as a SharedRuntime function command for keyboard shortcut override.
 */
async function saveToVault(event: Office.AddinCommands.Event): Promise<void> {
  try {
    window.dispatchEvent(new CustomEvent('ecsper:save-to-vault'));
  } catch {
    // Keyboard shortcut handler must always complete the event.
  } finally {
    event.completed();
  }
}

Office.onReady(() => {
  Office.actions.associate('SaveToVault', saveToVault);
});
